import { type FC, useState } from 'react';
import SearchInput from '../components/SearchInput';
import SearchContent from '../components/SearchContent';
import SearchQueriesList from '../components/SearchQueriesList';
import { twcls } from '@utils/twcls';
import { observer } from 'mobx-react';
import type { HeaderSearchSettings } from '..';
import './index.scss';
import SearchTips from '../components/SearchTips';

const HeaderSearchDesktop: FC<HeaderSearchSettings> = ({
  isLoading,
  showSearchResult,
  searchValue,
  searchData,
  itemForExample,
  searchQueries,
  isInputFocused,
  tips,
  isSearchPage,
  searchInputOnBlurInput,
  onClickInputContainer,
  searchInputOnKeyUp,
  searchHeader,
  clearInput,
  onClickForExample,
  onChangeLink,
  onRemove
}) => {
  const [isInputActuallyFocused, setIsInputActuallyFocused] = useState(false);
  return (
    <div
      className={'relative  bg-white h-[40.4px] w-full'}
      onClick={onClickInputContainer}
    >
      <div
        className={twcls(
          'absolute top-0 left-0 z-[444000] w-full overflow-hidden',
          isInputFocused &&
            !isSearchPage &&
            '-top-3 left-1/2 -translate-x-1/2 w-[900px] max-w-[900px] lg:w-[900px] lg:max-w-[900px]'
        )}
      >
        <div
          className={twcls(
            'relative flex flex-col gap-3  mb-1 bg-white rounded-2xl',
            isInputFocused && !isSearchPage && 'px-5 py-3'
          )}
        >
          <SearchInput
            value={searchValue}
            onChange={searchHeader}
            onFocus={() => {
              setIsInputActuallyFocused(true);
            }}
            onBlur={() => {
              setIsInputActuallyFocused(false);
              searchInputOnBlurInput();
            }}
            onKeyUp={searchInputOnKeyUp}
            clearInput={clearInput}
            onClickForExample={onClickForExample}
            itemForExample={itemForExample}
          />
          {isSearchPage && isInputActuallyFocused && !!tips?.length && (
            <SearchTips tips={tips} />
          )}
          {showSearchResult && (
            <>
              {searchValue ? (
                !!tips?.length && showSearchResult && <SearchTips tips={tips} />
              ) : searchQueries?.length > 0 ? (
                <SearchQueriesList
                  searchQueries={searchQueries}
                  onChangeLink={onChangeLink}
                  onRemove={onRemove}
                />
              ) : null}
            </>
          )}
        </div>
        {showSearchResult && (
          <div
            className={'static p-5 bg-white rounded-2xl'}
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <SearchContent
              isLoading={isLoading}
              searchValue={searchValue}
              products={searchData.products}
              categories={searchData.categories}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(HeaderSearchDesktop);
